import React, { useState } from 'react';

const Chat = () => {
  const [messages, setMessages] = useState([
    { id: 1, text: 'Hi! How can I help you today?', sender: 'system' },
  ]);
  const [input, setInput] = useState('');

  const sendMessage = () => {
    if (!input.trim()) return;
    setMessages([...messages, { id: messages.length + 1, text: input, sender: 'user' }]);
    setInput('');
    // Simulate a system response
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { id: prev.length + 1, text: 'I am just a demo chat!', sender: 'system' },
      ]);
    }, 1000);
  };

  return (
    <div className="flex flex-col h-full bg-white dark:bg-gray-900 p-4 rounded-lg shadow-md">
      <div className="flex-grow overflow-y-auto mb-4">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`mb-2 p-2 rounded ${
              message.sender === 'user'
                ? 'bg-blue-500 text-white text-right ml-auto max-w-xs'
                : 'bg-gray-300 text-black text-left mr-auto max-w-xs'
            }`}
          >
            {message.text}
          </div>
        ))}
      </div>
      <div className="flex">
        <input
          className="flex-grow px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-l-lg bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          type="text"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
        <button
          className="px-6 py-2 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700"
          onClick={sendMessage}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default Chat;
